import {addCase} from 'web/redux/actions/CaseActions';
import {fetchConditionSelection} from 'web/redux/actions/ConditionActions';
import {fetchCustomerSelection} from 'web/redux/actions/CustomerActions';
import {fetchDispatchList} from 'web/redux/actions/DispatchActions';
import {useState} from 'react';

import enumList from 'web/utils/enumList';

export const useFetchCalendar = (dispatch, showMessage) => {
  const [customerSelection, setCustomerSelection] = useState([]);
  const [conditionSelection, setConditionSelection] = useState([]);
  const [caseNumber, setCaseNumber] = useState('');

  const getCustomerSelection = () => {
    dispatch(fetchCustomerSelection({isNeededCasesNotAssign: true}))
      .then((response) => {
        const statusCode = response.payload.code;
        if (statusCode.isSuccessCode()) {
          const customerSelection = response.payload.result;
          setCustomerSelection(customerSelection);
        } else {
          showMessage(
            enumList.messageModalMode.error,
            response.payload.code,
            response.payload.message,
          );
        }
      })
      .catch((error) => {
        console.error('error:', error);
      });
  };
  const getConditionSelection = () => {
    dispatch(fetchConditionSelection({}))
      .then((response) => {
        const statusCode = response.payload.code;
        if (statusCode && statusCode.isSuccessCode()) {
          const conditionSelectionRes = response.payload.result;
          setConditionSelection(conditionSelectionRes);
        } else {
          showMessage(
            enumList.messageModalMode.error,
            response.payload.code,
            response.payload.message,
          );
        }
      })
      .catch((error) => {
        console.error('error:', error);
      });
  };
  const getAssignmentByCustomerCode = async (customerCode) => {
    try {
      const response = await dispatch(fetchDispatchList({customerCode}));
      console.log('[getAssignmentByCustomerCode] raw response:', response);
      if (response?.payload?.code && response.payload.code.isSuccessCode()) {
        return response.payload.result;
      } else {
        console.error(
          'fetch dispatch list error',
          response?.response?.data || response.message || response,
        );
        showMessage(
          enumList.messageModalMode.error,
          response?.payload?.code || '9999',
          response?.payload?.message || '取得派工清單失敗',
        );
        return [];
      }
    } catch (error) {
      console.error('getAssignmentByCustomerCode error:', error);
      showMessage(
        enumList.messageModalMode.error,
        '9999',
        '系統錯誤，請稍後再試',
      );
      return [];
    }
  };
  const handleAddCase = ({caseData, files}) => {
    dispatch(addCase({caseData, files}))
      .then((response) => {
        const statusCode = response.payload.code;
        if (statusCode.isSuccessCode()) {
          showMessage(enumList.messageModalMode.info, '立案成功');
        } else {
          showMessage(
            enumList.messageModalMode.error,
            response.payload.code,
            response.payload.message,
          );
        }
      })
      .catch((error) => {
        console.error('error:', error);
      });
  };

  return {
    getCustomerSelection,
    handleAddCase,
    getConditionSelection,
    getAssignmentByCustomerCode,
    setCaseNumber,
    caseNumber,
    customerSelection,
    conditionSelection,
  };
};
